import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import supportMessagesApi from '../services/supportMessagesApi';
import { formatApiError } from '../utils/errorMessage';

const SupportMessages = () => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const canView = user && (user.is_superuser || user.role === 'superuser' || user.platform_role === 'superuser');

  const load = async () => {
    try {
      setLoading(true);
      const res = await supportMessagesApi.list();
      setRows(res.data || []);
      setError('');
    } catch (loadError) {
      setError(formatApiError(loadError, 'Failed to load support messages'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canView) load();
  }, [canView]);

  const answer = async (id) => {
    try {
      await supportMessagesApi.answer(id);
      await load();
    } catch (answerError) {
      setError(formatApiError(answerError, 'Failed to mark answered'));
    }
  };

  if (!canView) {
    return <p>Superuser required</p>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Support messages</h1>
      {error && <p className="text-red-600 mb-4" role="alert">{error}</p>}
      {loading ? <p>Loading</p> : (
        <table className="min-w-full border">
          <thead>
            <tr>
              <th className="border px-2 py-1 text-left">Area</th>
              <th className="border px-2 py-1 text-left">Message</th>
              <th className="border px-2 py-1 text-left">Answered</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className="border px-2 py-1">{row.area}</td>
                <td className="border px-2 py-1">{row.message}</td>
                <td className="border px-2 py-1">
                  {row.answered_at ? 'Answered' : (
                    <button type="button" onClick={() => answer(row.id)}>Mark answered</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SupportMessages;
